import { useRouteNavigation } from "../../lib/common/routes";
import { TOnboardingMasterStep, TOnboardingProgressStatus } from "../../lib/types/onboarding_types";
import { RouteEnumType } from "../../lib/types/routes";
import { TUserTypes } from "../../lib/types/users";
import { useUserService } from "../../services/users";
import { OnboardingProgressCircle, OnboardingVerificationModals, useOnboardingStepNavigation } from "./onboarding-process";

type TProfileDockProps = {
    progress?: TOnboardingProgressStatus;
    nextStep: TOnboardingMasterStep | null;
    userType: TUserTypes;
};

export const ProfileDock = ({ progress, nextStep, userType }: TProfileDockProps) => {
    const { navigateToDashboardClickHandler } = useUserService();
    const { navigateRouteClickHandler } = useRouteNavigation();
    const { stepLabels, isPhoneVerified, showEmailModal, showPhoneModal, getStepHref, handleStepClick, closeEmailModal, closePhoneModal } =
        useOnboardingStepNavigation(userType);

    const progressPercentage = progress?.progress ?? 0;
    const nextStepLabel = nextStep ? stepLabels[nextStep.step_name as keyof typeof stepLabels] : "";
    const iconButtonClassName = "btn btn-primary shadow px-4 py-3 py-lg-2 fade-slide";
    const searchRoute: RouteEnumType = userType === "tech" ? "dentalLabSearch" : "dentalTechSearch";
    const searchButtonTitle = userType === "tech" ? "Search Employers on Map" : "Search Talent";

    const navigateToSearchClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
        navigateRouteClickHandler(searchRoute, e, "", true);
    };

    return (
        <>
            <div className="position-fixed start-50 translate-middle-x bottom-0 my-3 text-center rounded px-3 py-2 shadow button-dock">
                <div className={`row align-items-center flex-nowrap ${nextStep ? "gx-2" : "gx-3 justify-content-center"}`}>
                    {nextStep && (
                        <div className="col profile-dock__next-step-col">
                            <a
                                href={getStepHref(nextStep.step_name, `${nextStep.step_name}-progress`)}
                                onClick={(e) => handleStepClick(e, nextStep.step_name)}
                                className="btn btn-info text-white shadow px-2 py-2 fade-slide w-100 profile-dock__next-step-button"
                                title={nextStepLabel}
                            >
                                <span className="row gx-2 align-items-center flex-nowrap">
                                    <span className="col-auto">
                                        <OnboardingProgressCircle progressPercentage={progressPercentage} />
                                    </span>
                                    <span className="col text-start">
                                        <span className="d-block text-uppercase fw-semibold mb-1 lh-1 profile-dock__next-step-kicker">Next Step</span>
                                        <span className="d-block fw-bold lh-sm profile-dock__next-step-label">{nextStepLabel}</span>
                                    </span>
                                </span>
                            </a>
                        </div>
                    )}

                    <div className="col-auto">
                        <button className={iconButtonClassName} onClick={navigateToDashboardClickHandler} title="Go To Dashboard">
                            <i className={`fa-solid fa-house ${nextStep ? "" : "fa-lg"}`}></i>
                        </button>
                    </div>

                    <div className="col-auto">
                        <button className={iconButtonClassName} onClick={navigateToSearchClickHandler} title={searchButtonTitle}>
                            <i className={`fa-solid fa-magnifying-glass ${nextStep ? "" : "fa-lg"}`}></i>
                        </button>
                    </div>
                </div>
            </div>

            <OnboardingVerificationModals
                isPhoneVerified={isPhoneVerified}
                showEmailModal={showEmailModal}
                showPhoneModal={showPhoneModal}
                closeEmailModal={closeEmailModal}
                closePhoneModal={closePhoneModal}
            />
        </>
    );
};
